import {
  useEffect,
  useState
} from 'react';
import {SupportSlotsController} from '../../../../api/support/support-slots.controller';
import {SupportSlotDefinitionModel} from '../../../../model/support/slot/support-slot-definition.model';

export type SupportSlotDefinitionPreviewDetailsTabState = {
  slotDefinition: SupportSlotDefinitionModel
  setSlotDefinition: (value: SupportSlotDefinitionModel) => void
  onSlotDefinitionUpdated: () => Promise<void>
  onSlotDefinitionDeleted: () => Promise<void>
}

export const useSupportSlotDefinitionPreviewDetailsTabState = (initialSlotDefinition: SupportSlotDefinitionModel): SupportSlotDefinitionPreviewDetailsTabState => {
  const [slotDefinition, setSlotDefinition] = useState<SupportSlotDefinitionModel>(initialSlotDefinition)

  useEffect(() => {
    setSlotDefinition(initialSlotDefinition)
  }, [initialSlotDefinition])

  return {
    slotDefinition: slotDefinition,
    setSlotDefinition: setSlotDefinition,
    onSlotDefinitionUpdated: async () => {
      await SupportSlotsController.updateSupportSlotDefinition(initialSlotDefinition.id, slotDefinition.version, {
        startTime: slotDefinition.startTime,
        endTime: slotDefinition.endTime,
        validFrom: slotDefinition.validFrom,
        validTo: slotDefinition.validTo
      })
      setSlotDefinition({...slotDefinition, version: slotDefinition.version + 1})
    },
    onSlotDefinitionDeleted: async () => {
      await SupportSlotsController.deleteSupportSlotDefinition(initialSlotDefinition.id, slotDefinition.version)
    }
  }
}